import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@nx-ng/i18n';
import { ComponentsCommonModule } from '@modules/components-common';
import { TicketSelectorService } from './ticket-selector-service/ticket-selector.service';

@NgModule({
  imports: [CommonModule, I18nModule, ComponentsCommonModule],
  declarations: [],
  exports: [],
  providers: [TicketSelectorService],
})
export class TicketSelectorModule {}
